
const ChristmasData23 = [
    {
        id: 1,
        imageSource: require("../../../Assets/Events/2023/Christmas_Day_2023/CDay_1.webp")
    },
    {
        id: 2,
        imageSource: require("../../../Assets/Events/2023/Christmas_Day_2023/CDay_2.webp")
    },
    {
        id: 3,
        imageSource: require("../../../Assets/Events/2023/Christmas_Day_2023/CDay_3.webp")
    },
    {
        id: 4,
        imageSource: require("../../../Assets/Events/2023/Christmas_Day_2023/CDay_4.webp")
    },
    {
        id: 5,
        imageSource: require("../../../Assets/Events/2023/Christmas_Day_2023/CDay_5.webp")
    },
    {
        id: 6,
        imageSource: require("../../../Assets/Events/2023/Christmas_Day_2023/CDay_6.webp")
    }
];

export default ChristmasData23;